import React from 'react';

const SkiIcon = (props) => {
  return (
    <img
      alt="Stok narciarski"
      src="/static/images/icons/place_types/ski.svg"
      {...props}
    />
  );
};

export default SkiIcon;
